<footer class=" footer">
  <div class=" container-fluid">
    <ul class=" nav">
      <!--<li class=" nav-item">-->
        <!--<a class=" nav-link" href="https://www.creative-tim.com?ref=bda-footer">-->
          <!--Medis-->
        <!--</a>-->
      <!--</li>-->
      <!--<li class=" nav-item">-->
        <!--<a class=" nav-link" href="https://www.creative-tim.com/about-us?ref=bda-footer">-->
          <!--About Us-->
        <!--</a>-->
      <!--</li>-->
      <!--<li class=" nav-item">-->
        <!--<a class=" nav-link" href="http://blog.creative-tim.com?ref=bda-footer"> Blog </a>-->
      <!--</li>-->
    </ul>
    <div class=" copyright">
      <a href="https://medis.land" target="_blank"><img src="../../../../assets/img/MedisWhite.png" style="width: 3%;height: auto;"/> Powered by Medis</a><br/>
      &copy; {{ test | date: "yyyy" }}
      <!--made with-->
      <!--<i class=" tim-icons icon-heart-2"> </i> by-->

      <!--for a better web.-->
    </div>
  </div>
</footer>
